import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';

import { TranslateApplicationService } from '../../../services/translate/translate-application.service';
import { Language } from '../../../shared/enums';
import { LEARNING_HUB_MODULE_PATH } from '../../definitions/learning-hub.constants';
import { LearningHubLanguage, LearningHubLanguageOption } from '../../definitions/learning-hub.models';

/**
 * "Learning Hub" title (link to the home) on top of every page of the module. It has no language selector of its
 * own: the language is the one of the landing header (`.header-nav-elem.content-language`). When it changes the app
 * language (TranslateApplicationService), `selectLanguage` emits the matching option so the page moves to it.
 */
@Component({
  selector: 'app-learning-hub-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() lang: LearningHubLanguage;
  @Input() options: LearningHubLanguageOption[] = [];
  @Output() selectLanguage = new EventEmitter<LearningHubLanguageOption>();

  readonly modulePath = LEARNING_HUB_MODULE_PATH;

  private readonly DESTROY$ = new Subject<void>();

  constructor(private readonly _appLanguage: TranslateApplicationService) {}

  ngOnInit(): void {
    // skip(1): the BehaviorSubject replays the current app language, which the page already resolved.
    this._appLanguage.language$.pipe(skip(1), takeUntil(this.DESTROY$)).subscribe((appLanguage: Language) => {
      const code: string = appLanguage;
      const option = this.options.find((candidate: LearningHubLanguageOption) => candidate.lang === code);
      if (option?.available && option.lang !== this.lang) {
        this.selectLanguage.emit(option);
      }
    });
  }

  ngOnDestroy(): void {
    this.DESTROY$.next();
    this.DESTROY$.complete();
  }
}
